// extracted by mini-css-extract-plugin
export var bottom = "index-module--bottom--4ac31";
export var bottomRight = "index-module--bottomRight--578ee";
export var companyLogo = "index-module--companyLogo--1b97d";
export var copywrite = "index-module--copywrite--50815";
export var midWrapper = "index-module--midWrapper--38635";
export var middleRow = "index-module--middle-row--eaf52";
export var wrapper = "index-module--wrapper--cbba3";